import { Injectable } from '@angular/core';
import { ApiService } from '../../../../goldstar-share/src/app/api-data/ng-openapi-gen-next/services';
import { AccountApplicationLookupItem, AccountApplicationLookupItemRequest, AccountType } from '../../../../goldstar-share/src/app/api-data/ng-openapi-gen-next/models';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { lastValueFrom } from 'rxjs/internal/lastValueFrom';

@Injectable({
	providedIn: 'root',
})
export class MenuLoaderService {
	private readonly accountTypes: AccountType[] = [];
	private readonly accountPartyTypes: AccountApplicationLookupItem[] = [];
	private $accountTypes: BehaviorSubject<AccountType[]> = new BehaviorSubject(this.accountTypes);
	private $accountPartyTypes: BehaviorSubject<AccountApplicationLookupItem[]> = new BehaviorSubject(this.accountPartyTypes);

	constructor(private apiV2: ApiService) {}

	async fetchAllAccountTypes(): Promise<AccountType[]> {
		try {
			const fetchValueFromStore = this.$accountTypes.getValue();
			if (fetchValueFromStore.length <= 0) {
				const response = await lastValueFrom(
					this.apiV2.listAccountTypes({
						body: {
							searchFilter: [{ searchOption: 'ALL' }],
							pageSize: 1000,
						},
					})
				);
				if (response.isSuccess) {
					const accountTypes = response.data?.items ?? [];
					this.$accountTypes.next(accountTypes);
				}
			}
			return this.$accountTypes.getValue();
		} catch (error: any) {
			console.log('Error loading account types');
			return this.$accountTypes.getValue();
		}
	}

	async fetchAllAccountPartyTypes(): Promise<AccountApplicationLookupItem[]> {
		try {
			const fetchValueFromStore = this.$accountPartyTypes.getValue();
			if (fetchValueFromStore.length <= 0) {
				let request: AccountApplicationLookupItemRequest = {
					entityName: 'AccountOpeningPartySelection',
				};
				const response = await lastValueFrom(
					this.apiV2.accountPartyTypes({
						body: request,
					})
				);
				if (response.isSuccess) {
					const accountPartyTypes = response.data?.items ?? [];
					this.$accountPartyTypes.next(accountPartyTypes);
				}
			}
			return this.$accountPartyTypes.getValue();
		} catch (error: any) {
			console.log('Error loading account party types');
			return this.$accountPartyTypes.getValue();
		}
	}
}
